(function (w, $) {
    Tooltip = {
        tooltip: null,
        message: null,
        element: null,

        bind: function (selector) {
            $(document)
                .on('mouseover', selector, this.mouseover.bind(this))
                .on('mouseout', selector, this.mouseout.bind(this))
        },

        mouseover: function (e) {
            this.element = e.currentTarget
            let tooltipTarget = this.element.getAttribute('data-tooltip')

            if (tooltipTarget) {
                this.message = document.querySelector(tooltipTarget).innerHTML
            } else {
                this.message = item.getAttribute('title')
            }

            let tooltip = this.createTooltip()
            let width = tooltip.offsetWidth
            let height = tooltip.offsetHeight
            let left =
                + this.element.getBoundingClientRect().left
                + document.documentElement.scrollLeft
                + this.element.offsetWidth / 2
                - width / 2
            if (left > window.innerWidth - 35 - width) {
                left = window.innerWidth - 35 - width
            }
            if (left < 20) {
                left = 20
            }

            let top = this.element.getBoundingClientRect().top
                - height - 15
                + document.documentElement.scrollTop

            tooltip.style.left = left + 'px'
            tooltip.style.top = top + 'px'
            tooltip.classList.add('visible')
        },

        mouseout: function (e) {
            if (this.tooltip !== null) {
                this.tooltip.classList.remove('visible')
                document.body.removeChild(this.tooltip)
                this.tooltip = null
            }
        },

        createTooltip: function () {
            if (this.tooltip === null) {
                let tooltip = document.createElement('div')
                tooltip.innerHTML = this.message
                tooltip.classList.add('tooltipContainer')
                document.body.appendChild(tooltip)
                this.tooltip = tooltip
            }

            return this.tooltip
        }
    }

    $(function () {
        Tooltip.bind('.hasTooltip')
    })
})(window, jQuery)
